import partnerApi from "../api/partnerApi";
import {
  BodyParamsPostFile,
  PartnerLeadsResType,
  documentType,
  partnerApplicationsListQuery,
} from "../types/partnerApiTypes";
import introspectService from "./IntropsectService";

class PartnerService {
  postLeadFileService(data: documentType, leadId: any): Promise<string> {
    return partnerApi.postLeadFile(data, leadId);
  }
  
  postAskDocService(B: BodyParamsPostFile): Promise<any> {
    return partnerApi.postAskDoc(B);
  }

  postDocTemplateService(
    leadId: number,
    formData: FormData,
    onProgress: (percentage: number, loadedMB: string, totalMB: string) => void,
    signal: AbortSignal //to stop uploading
  ): Promise<any> {
    return partnerApi.postDocTemplate(leadId, formData, onProgress, signal);
  }

  deleteDocExampleService(documentId: number): Promise<any> {
    return partnerApi.deleteDocExample(documentId);
  }

  putLeadArchive(leadid: number) {
    return partnerApi
      .putLeadArchive(leadid)
      .then((res) => {
        return res;
      })
      .catch((error) => {
        introspectService.checkToken(error.response.status.toString());
        console.log(error);
      });
  }

  attachFileExampleService(
    baseDocumentId: number,
    clear: boolean,
    data: documentType
  ): Promise<string> {
    return partnerApi.attachFileExample(baseDocumentId, clear, data);
  }

  changeLeadStatusService(leadid: number, newStatus: string) {
    return partnerApi
      .changeLeadStatus(leadid, newStatus)
      .then((res) => {
        return res;
      })
      .catch((error) => {
        introspectService.checkToken(error.response.status.toString());
        console.log(error);
      });
  }

  getLeadsService(
    Q: partnerApplicationsListQuery
  ): Promise<PartnerLeadsResType> {
    return partnerApi.getLeads(Q);
  }

  takeOffLeadFlagNewService(leadid: number): Promise<string> {
    return partnerApi.takeOffLeadFlagNew(leadid);
  }
}

const partnerService = new PartnerService();
export default partnerService;
